export const FRAMEWORK_QUERY = '/framework';
export const FRAMEWORK_DEFAULT_CONFIG_QUERY = '/framework/config/default';
export const FRAMEWORK_CONFIG_QUERY = '/framework/config/connection';
export const COMBINED_FRAMEWORK_CONFIG_QUERY = '/framework/config/supplier';
